import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Avatar,
  Divider,
} from "@mui/material";
import { Edit as EditIcon, Save as SaveIcon } from "@mui/icons-material";
import { getCurrentUser, updateUser } from "../../services/API";
import { styles } from "./UserProfile.styles";

const UserProfile = () => {
  const [settings, setSettings] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await getCurrentUser();
        setSettings({
          firstName: userData.first_name || "",
          lastName: userData.last_name || "",
          email: userData.email || "",
          phone: userData.phone || "",
        });
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const updateData = {
        first_name: settings.firstName,
        last_name: settings.lastName,
        phone: settings.phone,
      };
      await updateUser(updateData);
      setIsEditing(false);
    } catch (error) {
      console.error("Failed to update settings:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <Paper elevation={3} sx={{ ...styles.paper, margin: 2 }}>
      <Box sx={styles.profileHeader}>
        <Avatar
          sx={styles.avatar}
          alt={`${settings.firstName} ${settings.lastName}`}
        >
          {settings.firstName?.[0]}
          {settings.lastName?.[0]}
        </Avatar>
        <Box>
          <Typography sx={styles.name}>
            {settings.firstName} {settings.lastName}
          </Typography>
          <Typography sx={styles.email}>{settings.email}</Typography>
        </Box>
      </Box>

      <Divider sx={{ mb: 0 }} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Typography sx={styles.sectionTitle}>Personal Information</Typography>
        <TextField
          sx={styles.formField}
          label="First Name"
          name="firstName"
          value={settings.firstName}
          onChange={handleChange}
          disabled={!isEditing}
        />
        <TextField
          sx={styles.formField}
          label="Last Name"
          name="lastName"
          value={settings.lastName}
          onChange={handleChange}
          disabled={!isEditing}
        />
        <TextField
          sx={styles.formField}
          label="Email"
          name="email"
          value={settings.email}
          onChange={handleChange}
          disabled={true}
        />
        <TextField
          sx={styles.formField}
          label="Phone"
          name="phone"
          value={settings.phone}
          onChange={handleChange}
          disabled={!isEditing}
        />
      </Box>

      <Box sx={styles.actionButton}>
        {isEditing ? (
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={handleSave}
            disabled={loading}
            sx={styles.saveButton}
          >
            Save Changes
          </Button>
        ) : (
          <Button
            variant="outlined"
            startIcon={<EditIcon />}
            onClick={() => setIsEditing(true)}
            sx={styles.editButton}
          >
            Edit Profile
          </Button>
        )}
      </Box>
    </Paper>
  );
};

export default UserProfile;
